import Tags from '../../services/tags'
import * as types from "../mutationTypes";

let state = {
    tags: null,
    tag: null,
    error: null
}
let getters = {
    tags (state) {
        return state.tags
    },
    tag (state) {
        return state.tag
    },
    error (state)
    {
        return state.error
    }
}
const mutations = {
    [types.REQUEST_GET_ALL_TAGS_SUCCESS] (state, tags) {
        state.tags = tags
        state.error = null
    },
    [types.REQUEST_GET_ALL_TAGS_ERROR] (state, message) {
        state.error = message
        state.tags = null
    },
    [types.REQUEST_GET_TAG_BY_ID_SUCCESS] (state, tag) {
        state.tag = tag
        state.error = null
    },
    [types.REQUEST_GET_TAG_BY_ID_ERROR] (state, message) {
        state.error = message
        state.tag = null
    },
    [types.REQUEST_UPDATE_TAG_SUCCESS] (state, tag) {
        state.tag = tag
        state.error = null
    },
    [types.REQUEST_UPDATE_TAG_ERROR] (state, message) {
        state.error = message
        state.tag = null
    },
    [types.REQUEST_DELETE_TAG_SUCCESS] (state, tag) {
        state.tag = tag
        state.error = null
    },
    [types.REQUEST_DELETE_TAG_ERROR] (state, message) {
        state.error = message
        state.tag = null
    },
    [types.REQUEST_CREATE_TAG_SUCCESS] (state, tag) {
        state.tag = tag
        state.error = null
    },
    [types.REQUEST_CREATE_TAG_ERROR] (state, message) {
        state.error = message
        state.tag = null
    },
}
const actions = {
    async getAll ({ commit }) {
        try {
            let res = await Tags.get()
            if (res) {
                commit(types.REQUEST_GET_ALL_TAGS_SUCCESS, res.data)
            }
        } catch (error) {
            commit(types.REQUEST_GET_ALL_TAGS_ERROR, error.message)
        }
    },
    async getById ({ commit }, id) {
        try {
            let res = await Tags.getById(id)
            if (res) {
                commit(types.REQUEST_GET_TAG_BY_ID_SUCCESS, res.data)
            }
        } catch (error) {
            commit(types.REQUEST_GET_TAG_BY_ID_ERROR, error.message)
        }
    },
    async delete ({ commit }, id) {
        try {
            let res = await Tags.delete(id)
            if (res) {
                commit(types.REQUEST_DELETE_TAG_SUCCESS, res.data)
            }
        } catch (error) {
            commit(types.REQUEST_DELETE_TAG_ERROR, error.message)
        }
    },
    async create ({ commit, dispatch }, tagsToCreate) {
        try {
            let res = await Tags.create(tagsToCreate)
            if (res) {
                commit(types.REQUEST_CREATE_TAG_SUCCESS, res.data)
                dispatch('getAll', {})
                return res.data.id;
            }
        } catch (error) {
            commit(types.REQUEST_CREATE_TAG_ERROR, error.message)

        }
        return null;
    },
    async update ({ commit, dispatch }, id, tagsToUpdate) {
        try {
            let res = await Tags.update(id, tagsToUpdate)
            if (res) {
                commit(types.REQUEST_UPDATE_TAG_SUCCESS, res.data)
                dispatch('getAll', {})
            }
        } catch (error) {
            commit(types.REQUEST_UPDATE_TAG_ERROR, error.message)
        }
    },

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
